import { useState } from "react";

import { toast } from "sonner";

import service from "@/components/admin-components/blockchain-network/service";

interface Props {
  refresh: () => Promise<void>;
}

export const useBlockchainNetworkMutations = ({ refresh }: Props) => {
  const [loading, setLoading] = useState(false);

  const execute = async (action: () => Promise<any>, message: string) => {
    try {
      setLoading(true);

      await action();

      toast.success(message);

      await refresh();

      return true;
    } catch (error: any) {
      toast.error(error?.response?.data?.message ?? "Something went wrong.");

      return false;
    } finally {
      setLoading(false);
    }
  };

  const deleteNetwork = (id: string) =>
    execute(() => service.delete(id), "Blockchain network deleted.");

  const enableNetwork = (id: string) =>
    execute(() => service.enable(id), "Network enabled.");

  const disableNetwork = (id: string) =>
    execute(() => service.disable(id), "Network disabled.");

  const enableDeposits = (id: string) =>
    execute(() => service.enableDeposits(id), "Deposits enabled.");

  const disableDeposits = (id: string) =>
    execute(() => service.disableDeposits(id), "Deposits disabled.");

  const enableWithdrawals = (id: string) =>
    execute(() => service.enableWithdrawals(id), "Withdrawals enabled.");

  const disableWithdrawals = (id: string) =>
    execute(() => service.disableWithdrawals(id), "Withdrawals disabled.");

  return {
    loading,

    deleteNetwork,

    enableNetwork,

    disableNetwork,

    enableDeposits,

    disableDeposits,

    enableWithdrawals,

    disableWithdrawals,
  };
};
